import { render } from "./SplClients.vue?vue&type=template&id=aa28e418"
import script from "./SplClients.vue?vue&type=script&lang=js"
export * from "./SplClients.vue?vue&type=script&lang=js"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__